import { render, staticRenderFns } from "./appletNonor.vue?vue&type=template&id=5f1ac006&scoped=true"
import script from "./appletNonor.vue?vue&type=script&lang=js"
export * from "./appletNonor.vue?vue&type=script&lang=js"
import style0 from "./appletNonor.vue?vue&type=style&index=0&id=5f1ac006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ac006",
  null
  
)

export default component.exports